import { render, staticRenderFns } from "./carInsurance.vue?vue&type=template&id=c7ed80ac&scoped=true"
import script from "./carInsurance.vue?vue&type=script&lang=js"
export * from "./carInsurance.vue?vue&type=script&lang=js"
import style0 from "./carInsurance.vue?vue&type=style&index=0&id=c7ed80ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ed80ac",
  null
  
)

export default component.exports